/** Verify Goods admin panel branding */
export const branding = {
  productName: 'Verify Goods',
  productSubtitle: 'Authenticity platform',
  sidebarFooter: 'Verify Goods',
  themeColor: '#1d6b4f',
  loginTitle: 'Verify Goods',
  loginSubtitle: 'Super Admin — platform console',
  brandLoginTitle: 'Verify Goods',
  brandLoginSubtitle: 'Brand portal — sign in to your brand account',
};
